import * as Sentry from '@sentry/browser'
import axios from 'axios'
import _get from 'lodash/get'

import { handleRequestError } from './request'

export const SEND_MAGIC_LINK = 'SEND_MAGIC_LINK'
export const RESOLVE_MAGIC_LINK = 'RESOLVE_MAGIC_LINK'

export const sendMagicLink = (data) => (dispatch) => {
    dispatch({ type: SEND_MAGIC_LINK, data })

    const { phoneNumber, url } = data

    return axios.post('/magiclink', { phoneNumber, url }).catch((error) => {
        dispatch(
            handleRequestError(error, {
                hideAlert: true,
                customMessage: 'There was a problem sending a link, please check the phone number or try again later',
            })
        )
        return Promise.reject(error)
    })
}

export const resolveMagicLink = (data) => (dispatch) => {
    dispatch({ type: RESOLVE_MAGIC_LINK, data })

    const { identifier } = data

    return axios.get(`/magiclink/${identifier}`).then((response) => {
        const { accessToken, url } = _get(response, ['data'])

        if (!accessToken || !url) {
            Sentry.withScope((scope) => {
                scope.setContext('params', { action: 'resolveMagicLink', identifier, response })
                Sentry.captureMessage("Couldn't find 'accessToken' and/or 'url' in the magiclink response")
            })

            return Promise.reject(new Error())
        }

        return Promise.resolve({ accessToken, url })
    })
}
